import { Selector } from '@ngrx/store';

import * as RouterStoreSelectors from './router.selector';

export const selectLocation: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('location');

export const selectRoom: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('room');
